var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#EB0042"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96289 8.5376C6.13218 8.5376 6.27741 8.59162 6.39453 8.70166H6.39355C6.51905 8.81296 6.5752 8.9965 6.5752 9.23682C6.57514 9.47493 6.51838 9.66018 6.39453 9.78076C6.27753 9.89429 6.13259 9.95068 5.96289 9.95068C5.7903 9.95068 5.64358 9.89453 5.52637 9.78076L5.52539 9.77979C5.40528 9.65916 5.35064 9.47436 5.35059 9.23682C5.35059 8.99635 5.40479 8.81199 5.52734 8.70068C5.64453 8.59093 5.79112 8.5376 5.96289 8.5376ZM6.49707 2.35107L6.49512 2.40283L6.27734 7.71826L6.27539 7.76611H5.66406L5.66211 7.71826L5.44531 2.40283L5.44238 2.35107H6.49707Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.54668ef1e94d89fbd82c74c18454f232.svg";
export { ForwardRef as ReactComponent };